module.exports = __webpack_public_path__ + "a5ce92d029db4628a78b86aaf377db80.png";